import { render, staticRenderFns } from "./TheBatchSearchTable.vue?vue&type=template&id=30c077a9"
import script from "./TheBatchSearchTable.vue?vue&type=script&lang=ts"
export * from "./TheBatchSearchTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports